import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ToolbarButton} from '../../../../../../libs/shared/ui/src/components/buttons/toolbarButton';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {EmojiDropdownContainer} from '../../../../common/dropdowns/emoji/emojiDropdownContainer';

/*
 * Props.
 */

export interface EmojiToolbarButtonProps {
  onEmojiSelect?: HandlerOf<string>;
}

/*
 * Component.
 */

export const EmojiToolbarButton: FC<EmojiToolbarButtonProps> = ({onEmojiSelect}) => (
  <PopoverCoordinator
    renderButton={(isOpen) => renderButton(isOpen)}
    renderModal={(modalProps) => renderDropdown(modalProps, onEmojiSelect)}
  />
);

/*
 * Button.
 */

function renderButton(isOpen: boolean) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <ToolbarButton
          iconName="emoji"
          hasHover={isOpen}
          label={<Trans id="composer-toolbar-insert-emoji">Insert emoji</Trans>}
          shouldPreventMouseDown
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
        />
      )}
    </UserThemeConsumer>
  );
}

/*
 * Dropdown.
 */

function renderDropdown(modalProps: PopoverTransferProps, onEmojiSelect?: HandlerOf<string>) {
  return <EmojiDropdownContainer {...modalProps} onEmojiSelect={modalProps.wrap(onEmojiSelect)} />;
}
